import { Directive, computed, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
    selector: '[hlmAlertDesc],[hlmAlertDescription]',
    host: {
        '[class]': '_computedClass()',
    },
})
export class HlmAlertDescription {
    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    protected readonly _computedClass = computed(() =>
        hlm('col-start-2 grid justify-items-start gap-1 [&_p]:leading-relaxed text-sm caption-normal', this.userClass())
    );
}
